export default __webpack_public_path__ + "static/media/skills_arrow.956cab19.svg";